/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import CitrixModel from 'apmui/resource/remoteDesktop/CitrixModel';
import VmwareViewModel from 'apmui/resource/remoteDesktop/VmwareViewModel';
import VdiError, { VdiErrorType } from 'apmui/resource/remoteDesktop/VdiError';
import IDialogConfiguration, { DialogType } from 'apmui/components/dialog/Model';
import { REMOTE_DESKTOP_TYPE } from 'apmui/resource/remoteDesktop/Model';
import VdiClientInfo from 'apmui/resource/remoteDesktop/VdiClientInfo';

interface IErrorInfo {
    caption: string;
    message: string;
}

type ClientInfo = Partial<Record<REMOTE_DESKTOP_TYPE, VdiClientInfo>>;

interface IVdiDialogParams {
    error?: VdiError | Error;
    resource?: CitrixModel | VmwareViewModel;
    clients?: ClientInfo;
}

interface IVdiStrings {
    cancel_button: string;
    ok_button: string;
    retry_button: string;
    close_button: string;

    select_client_caption: string;
    select_client_message: string;

    native_client_download_message: string;
    settings_dialog_caption: string;
    settings_admin_enforced_client_message: string;

    citrix_admin_preferred_client?: string;
    view_admin_preferred_client?: string;

    // logon form
    logon_form_caption: string;
    username_label: string;
    password_label: string;
    domain_label: string;
    logon_button: string;

    // destination dialog
    user_def_dst_label: string;
    user_def_dst_form_caption: string;
}

type VdiDialogType =
    | DialogType.VDI_DESTINATION
    | DialogType.VDI_ERROR
    | DialogType.VDI_LOGON
    | DialogType.VDI_LAUNCH_CLIENT
    | DialogType.VDI_SETTINGS;

interface IVdiModel {
    strings: IVdiStrings;
    // error captions/messages
    error: Record<VdiErrorType, IErrorInfo>;

    hasCitrixResources: boolean;
    hasVmwareViewResources: boolean;
    clients?: ClientInfo;

    /** VDI dialogs */
    dialogs: Record<VdiDialogType, IDialogConfiguration>;
}

export { IVdiModel as default, IErrorInfo, IVdiModel, IVdiDialogParams, IVdiStrings, VdiDialogType };
